<template>
    <div class="order-wrapper" v-loading="loading" element-loading-text="拼命加载中">
        <div class="section-wrapper">
            <order_head :order="orderData" :check_type="check_type"></order_head>
            <el-tabs  type="border-card" class="order-detail-section mg20" v-model="activeTab">
                <el-tab-pane label="财务信息" v-if="orderData.finance && orderData.finance"  name="2">
                    <order_line :order.sync="orderData" :type="orderData.type" :tab="params.FINANCE_LINE"></order_line>
                </el-tab-pane>
                <el-tab-pane label="合同附件" v-if="orderData.contracts && orderData.contracts.length>0" name="3">
                    <order_line  :order.sync="orderData" :type="orderData.type" :tab="params.CONTRACT_LINE"></order_line>
                </el-tab-pane>
                <el-tab-pane label="客户签约历史" name="order" v-if="orderData.customer_id">
                    <order-table :customer_id=orderData.customer_id></order-table>
                </el-tab-pane>
            </el-tabs>
            <!--产品信息-->
            <product-basic-info  :order.sync="orderData"></product-basic-info>
            <!--财务信息-->
            <div v-if="activeTab == params.FINANCE_LINE">
                <order_contract_time :order.sync="orderData"></order_contract_time>
                <order_performance v-if="orderData.type !=1" :order.sync="orderData"></order_performance>
                <order_customer_info :order.sync="orderData"></order_customer_info>
                <order_scale :order.sync="orderData"></order_scale>
                <order_plan_pay v-if="orderData.type !=1" :order.sync="orderData"></order_plan_pay>
                
                <!-- 创建附件展示 -->
                <el-card v-if="orderData.createAttachment && orderData.createAttachment.length > 0" class="box-card order-detail-section mg20">
                    <div slot="header">
                        <span>附件</span>
                    </div>
                    <el-row class="userInfo-group" v-for="(item, index) in orderData.createAttachment" :key="item.id">
                        <el-row>
                            <el-col :span="12" class="order-item"><a :href="item.url" target="_blank"><i
                                    class="el-icon-document"></i>{{item.name}}</a></el-col>
                        </el-row>
                    </el-row>
                </el-card>
                <div class="order-detail-section mg20"
                     v-if="orderData.finance && orderData.finance.express && orderData.finance.invoice && orderData.type != params.TYPE_TRY_OUT">
                    <h3>其他信息</h3>
                    <div class="order-userInfo">
                        <order_invoice :order.sync="orderData"></order_invoice>
                        <order_address :order="orderData"></order_address>
                        <order_logistic :order.sync="orderData"></order_logistic>
                        <order_finance_other :order.sync="orderData"></order_finance_other>
                    </div>
                </div>
            </div>
            <!--合同附件-->
            <div v-if="activeTab == params.CONTRACT_LINE">
                <order_contract :order="orderData"></order_contract>
            </div>
        </div>
    </div>
</template>
<script>

    import {OrderMixin} from "~/services/OrderMixin";
    import Params from "~/config/params";
    import Order_progress from "~/views/order/partial/order_progress.vue";
    import Order_product from "~/views/order/partial/order_product.vue";
    import order_contract from "~/views/order/partial/order_contract.vue";
    import order_invoice from "~/views/order/partial/order_invoice.vue";
    import order_address from "~/views/order/partial/order_address.vue";
    import order_logistic from "~/views/order/partial/order_logistic.vue";
    import order_plan_pay from "~/views/order/partial/order_plan_pay.vue";
    import order_customer_info from "~/views/order/partial/order_customer_info.vue";
    import order_performance from "~/views/order/partial/order_performance.vue";
    import order_line from "~/views/order/partial/order_line.vue";
    import order_finance_other from "~/views/order/partial/order_finance_other.vue";
    import order_contract_time from "~/views/order/partial/order_contract_time.vue";
    import OrderTable from "~/views/order/partial/order_table.vue";
    import order_scale from "~/views/order/partial/order_scale.vue";
    export default {
        mixins:[OrderMixin],
        data() {
            return {

            };
        },
        components: {
            Order_product,
            Order_progress,
            order_contract,
            order_invoice,
            order_address,
            order_logistic,
            order_plan_pay,
            order_customer_info,
            order_performance,
            order_line,
            order_finance_other,
            order_contract_time,
            OrderTable,
            order_scale
        },
        created() {

        },
        methods: {

        },
        mounted() {
            this.params = Params;
            this.$nextTick(function () {
                this.getOrder(this.id);
            });
        }
    }
</script>




// WEBPACK FOOTER //
// src/views/order/approve/createOrder.vue